angular.module('lsnBase.deprecated.models')
  .factory('SubjectSelectUiConfigModel', ['LsnSubjectSelectUiConfigModelV1',
    function(LsnSubjectSelectUiConfigModelV1) {
      return LsnSubjectSelectUiConfigModelV1;
    }
  ]);